import { FC } from 'react';

import OrganizationsSelector from 'components/selectors/OrganizationsSelector';
import CancelButton from './group/CancelButton';
import SaveButton from './group/SaveButton';

type OrganizationOption = {
  id: number | string;
  name: string;
};

type TitleProps = {
  selectedCompany: OrganizationOption | null;
  onCompanyChange: (company: OrganizationOption | null) => void;
  onCancel: () => void;
  onSave: () => void;
  disableCancel?: boolean;
  disableSave?: boolean;
};

const Title: FC<TitleProps> = ({
  selectedCompany,
  onCompanyChange,
  onCancel,
  onSave,
  disableCancel,
  disableSave
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center flex-1">
        <div className="min-w-248">
          <OrganizationsSelector
            getOptionValue={(option: OrganizationOption) => option.id}
            getOptionLabel={(option: OrganizationOption) => option.name}
            filter={{ value: selectedCompany }}
            onChange={({ value }: { value: OrganizationOption | '' }) => {
              onCompanyChange(value || null);
            }}
            isMulti={false}
            styled={false}
            size="lg"
            placeholder="Select company"
            isClearable={false}
            autoFocus={false}
          />
        </div>
      </div>
      <div className="d-flex align-items-center">
        <CancelButton onClick={onCancel} disabled={disableCancel} />
        <div className="cms-12">
          <SaveButton onClick={onSave} disabled={disableSave} />
        </div>
      </div>
    </div>
  );
};

export default Title;
